import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  setCookie(cookieName: string, data: string, date: Date): void
  setCookie(cookieName: string, data: string, expirationDays: number): void
  setCookie(cookieName: string, data: string, exp: Date | number): void {
    let expDate: Date;
    if (typeof exp === 'number') {
      let date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000)
      expDate = date
    } else {
      expDate = new Date(exp)
    }
    document.cookie = `${cookieName}=${data}; expires=${expDate.toUTCString()}; path:/; SameSite=Strict`;
  }

  getCookie(name: string): string | null {
    let decodeCookie = decodeURIComponent(document.cookie)
    for (let cookie of decodeCookie.split(';')) {
      let value = cookie.trim();
      if (value.startsWith(name)) {
        return value.substring(name.length + 1)
      }
    }
    return null;
  }

  clearCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  hasCookie(name: string): boolean {
    return !!this.getCookie(name);
  }

}
